import styled from "styled-components";

export const ModalOverlay = styled.div`
    background: #00000089;
    position: fixed;
    height: 100%;
    width: 100%;
    display: ${(props) => props.open ? "flex" : "none"};
    justify-content: center;
    align-items: center;
    top: 0;
    z-index: 1;
    overflow: hidden;
`;

export const ModalContainer = styled.div`
    display: ${(props) => props.open ? "flex" : "none"};
    position: fixed;
    z-index: 2;
    width: 50%;
    height: 100vh;
    display: flex;
    justify-content: right;
    align-items: center;
    top: 10px;
    right: 0px;
    @media (max-width: 768px) {
        width: 100%;
    }
`;


export const Container = styled.div`
    background: #fff;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);
    height: 103vh;
    width: 60%;
    overflow: auto;
    padding: 20px 24px;
    @media (max-width: 1285px) {
        width: 65%;
    }
    @media (max-width: 1010px) {
        width: 70%;
    }
    @media (max-width: 768px) {
        width: 100%;
    }
    &::-webkit-scrollbar{
        /* display: none; */
    }
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    margin-top: 20px;
`;

export const BackArrow = styled.div`
    font-size: 24px;
    margin-right: 10px;
    padding: 0px 6px;
    cursor: pointer;
    border-radius: 40px;
`;

export const TitleHeader = styled.div`
    font-size: 24px;
    font-weight: 600;
    color: #333;
`;

export const Section = styled.div`
    margin-bottom: 16px;
`;

export const Label = styled.div`
    font-size: 14px;
    color: #888;
    margin-bottom: 4px;
`;

export const Value = styled.div`
    font-size: 18px;
    color: #111;
    font-weight: 500;
`;

export const Attachment = styled.div`
    display: flex;
    align-items: center;
    background: #f9f9f9;
    padding: 10px;
    border-radius: 8px;
    margin-top: 10px;
`;

export const AttachmentImage = styled.img`
    width: 100%;
    margin-right: 10px;
`;

export const StatusSelect = styled.select`
     width: 100%;
      padding: 8px;
      font-size: 14px;
      border: 1px solid #ccc;
      border-radius: 6px;
      background: #fff;
      margin-top: 4px;
`;

export const UpdateButton = styled.button`
     width: 100%;
  padding: 10px;
  font-size: 14px;
  background-color: #28a745; /* Hijau */
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s ease;
      &:hover{
        background-color: #218838; /* Hijau lebih gelap saat hover */
      }
`;
export const UpdateButtonRejected = styled.button`
      width: 100%;
  padding: 10px;
  font-size: 14px;
  background-color: #dc3545; /* Merah */
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #c82333; /* Merah lebih gelap saat hover */
  }
`;

export const Notifiation = styled.div`
      margin-top: 10px;
      font-size: 13px;
      color: green;
      display: inline;
`;